export const DEFAULT_SITE_MATCH_ENDPOINT = 'match-domain-url'

const LEGACY_SITE_MATCH_ENDPOINT = 'match-url'

export function normalizeSiteMatchEndpoint(value) {
  const endpoint = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .pop()

  return endpoint === LEGACY_SITE_MATCH_ENDPOINT
    ? LEGACY_SITE_MATCH_ENDPOINT
    : DEFAULT_SITE_MATCH_ENDPOINT
}

export function getSiteMatchEndpointPath(
  value,
  prefix = '/frontServer/display-config',
) {
  return `${String(prefix || '').replace(/\/+$/g, '')}/${normalizeSiteMatchEndpoint(value)}`
}
